import { api } from '@setplex/tria-api'
import { createEffect, attach, createStore } from 'effector'
import { logger } from '~/shared/logger'
import { modules } from '~/shared/config'
import { model as guest } from '~/features/subscriber/guest'
import { options, features } from '~/core/flags'
import type { RowsPage, TGetRowsFx } from './index.h'
import { filterRowsVisibility } from './lib'

const getFilteredRowsFx = createEffect(
  async ({ source, params }: TGetRowsFx) => {
    let rows: RowsPage

    try {
      rows = await api.appearance.getModuleRowsFx(params)
    } catch (error) {
      logger.error(`Failed to load ${params.identifier} rows:`, error)
      throw error
    }

    rows.content = filterRowsVisibility(rows, source)

    return rows
  }
)

export const $customFx = createStore<Record<
  string,
  typeof getFilteredRowsFx
> | null>(null)

export const getRowsFx = attach({
  source: {
    features: features.$featuredFlags,
    options: options.$optionsFlags,
    modules: modules.$visibility,
    isGuest: guest.$guest,
    customFx: $customFx,
  },
  async effect(source, params) {
    try {
      const customFx = source.customFx?.[params.identifier]

      if (customFx) return customFx({ source, params })

      return getFilteredRowsFx({ source, params })
    } catch (error) {
      logger.error(
        `Failed to choose effect for ${params.identifier} rows:`,
        error
      )
      throw error
    }
  },
})
